import EmbeddedViralLink from 'viral-links-lib/embedded-viral-link/EmbeddedViralLink';
import getLangLocale from 'I18n/utils/getLangLocale';
import { Component } from 'react';
import { connect } from 'react-redux';
import { View } from 'foundations-components/components/View';
import enviro from 'enviro';
import { jsx as _jsx } from "react/jsx-runtime";
function FreemiumLink({
  embedded,
  portalId
}) {
  const linkType = embedded ? `meetings-embedded` : `meetings`;
  const environment = enviro.isQa() ? 'qa' : 'prod';
  return /*#__PURE__*/_jsx(View, {
    textAlign: "center",
    inlineSize: "100%",
    backgroundColor: "fill-surface-default",
    paddingBlock: embedded ? '200' : '300',
    borderBlockEndColor: "border-core-default",
    boxShadow: "400",
    children: /*#__PURE__*/_jsx(EmbeddedViralLink, {
      linkType: linkType,
      langOverride: getLangLocale(),
      additionalParams: {
        /*  @ts-expect-error Jun-23-2025, 19:10UTC fix types  */
        portalId,
        /*  @ts-expect-error Jun-23-2025, 19:10UTC fix types  */
        isExternalLink: embedded,
        environment
      }
    })
  });
}
class FreemiumBookingUpgradeLink extends Component {
  render() {
    const {
      embedded,
      portalId
    } = this.props;
    return /*#__PURE__*/_jsx(FreemiumLink, {
      embedded: embedded,
      portalId: portalId
    });
  }
}
export default connect(state => ({
  portalId: state.portalId
}))(FreemiumBookingUpgradeLink);